import styled from '@emotion/styled'

export const UploadContainer = styled.div`
  width: 100%;
  max-width: 600px;
`
